import React from 'react';
export const Checkbox = props => {
  const {
    param,
    data
  } = props;
  return <div>{!!data[param.key] ? 'Yes' : 'No'}</div>;
};